import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import { isNativeMobile } from "global/utils/platformDetector";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { OtrosTramites } from "_+_Portal/assets/images/generico/OtrosTramites";
import { LimpiarSelectGlobal } from "_+_Portal/context/Actions/DropDownFamiliares/selectFamiliares";
import { hideModal, showModal } from "_+_Portal/context/Actions/modal/modal";
import { PortalContext } from "_+_Portal/context/Provider";
import {
  setCircuito,
  setPaso,
} from "_+_Portal/_-_Autocheckin/context/action/paso";
import {
  wsGetTurnosConPresente,
  wsGetTurnosPacienteDelDia,
} from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import { setTurnosRecepcionadosAll } from "_+_Portal/_-_Autocheckin/context/action/turnosRecepcionados";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { BtnContainer, ContianerHome, HeaderHomeBar } from "./localStyle";
import { setAvisoAutocheck } from "_+_Portal/_-_Autocheckin/context/action/avisoAutocheck";
import { OrderTurnosLabo, turnosOrdenamiento } from "../PagesFun";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { wsGetOrdenDigitalEstudio } from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import { wsGetLabOrdenDigital } from "_+_Portal/context/Actions/labOrdenDigital/labOrdenDigital";
import { wsGetTextos } from "_+_Portal/context/Actions/textos/textos";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import AlertIconFilled from "_+_Portal/assets/images/generico/AlertIconFilled";
import InjectionIcon from "_+_Portal/assets/images/generico/InjectionIcon";
import LogoDim from "_+_Portal/assets/images/generico/LogoDim";
import MiTurnoIcon from "_+_Portal/assets/images/generico/MiTurnoIcon";
import OrdenesDigitalesIcon from "_+_Portal/assets/images/generico/OrdenesDigitalesIcon";
import RelojIcon from "_+_Portal/assets/images/generico/RelojIcon";
import CalendarCheckIcon from "_+_Portal/assets/images/generico/CalendarCheckIcon";
import CalendarSearchIcon from "_+_Portal/assets/images/generico/CalendarSearchIcon";
import Layout from "global/component/Genericos/Layout/Layout";
import camelize from "global/utils/camelize";

const Home = ({ setLoading, setPasoSelectFamiliar }) => {
  // -------------------------  context ----------------------------
  const {
    pasoDispatch,
    turnosAutoCheckInDispatch,
    turnosRecepcionadosDispatch,
    turnosSeleccionadosDispatch,
    avisoAutocheckState,
    avisoAutocheckDispatch,
    textosAutoCheckinState,
    puntoControlDispatch,
    ubicacionState,
  } = useContext(AutocheckContext);
  const { authState, toasterDispatch } = useContext(GlobalContext);
  const {
    modalDispatch,
    selectDropDownState,
    textosState,
    estudioGrupoState,
    selectDropDownDispatch,
    ordenDigitalDispatch,
    labOrdenDigitalDispatch,
    textosDispatch,
  } = useContext(PortalContext);

  // -------------------------  context ----------------------------
  const [dataLoading, setDataLoading] = useState(true);
  const [ordenesLoading, setOrdenesLoading] = useState(false);
  const [nextStepTo, setNextStepTo] = useState(true);
  // Estados separados para cada tipo de turno
  const [hayTurnosRecepcionados, setHayTurnosRecepcionados] = useState(false);
  const [hayTurnosPendientes, setHayTurnosPendientes] = useState(false);
  // -------------------------  useStates ----------------------------

  // ========================= MOCK DATA PARA TESTING =========================
  // Cambiar a true para activar el mock y probar ambos caminos
  const MOCK_ENABLED = false; // DESACTIVADO - usar datos reales

  // Mock de turnos con diferentes estados
  const MOCK_TURNOS = {
    // Turnos ya recepcionados (con presente = true)
    recepcionados: [
      {
        idturno: 1001,
        especialidad: "CARDIOLOGÍA",
        hora: "09:30",
        centro: "DIM San Martín",
        medico: "Dr. García Juan",
        presente: true,
        checkin: true,
        ausente: false,
        flgSoloConsulta: true,
        consultorio: "Consultorio 5",
        idProtocolo: 0,
      },
      {
        idturno: 1002,
        especialidad: "TRAUMATOLOGÍA",
        hora: "11:00",
        centro: "DIM San Martín",
        medico: "Dra. López María",
        presente: true,
        checkin: true,
        ausente: false,
        flgSoloConsulta: true,
        consultorio: "Consultorio 8",
        idProtocolo: 0,
      },
    ],
    // Turnos pendientes de recepcionar (sin presente)
    pendientes: [
      {
        idturno: 2001,
        especialidad: "DERMATOLOGÍA",
        hora: "14:00",
        centro: "DIM Centro",
        medico: "Dr. Martínez Pedro",
        presente: false,
        checkin: false,
        ausente: false,
        flgSoloConsulta: true,
        consultorio: "",
        idProtocolo: 0,
        selected: false,
      },
      {
        idturno: 2002,
        especialidad: "OFTALMOLOGÍA",
        hora: "16:30",
        centro: "DIM Centro",
        medico: "Dra. Fernández Ana",
        presente: false,
        checkin: false,
        ausente: false,
        flgSoloConsulta: true,
        consultorio: "",
        idProtocolo: 0,
        selected: false,
      },
    ],
  };

  // Función para activar mock data al cargar
  useEffect(() => {
    if (MOCK_ENABLED) {
      console.log("🧪 MOCK MODE ACTIVADO - Simulando turnos");
      // Simular que hay ambos tipos de turnos
      setHayTurnosRecepcionados(true); // Ambos en true para probar los 2 botones
      setHayTurnosPendientes(true);
      setNextStepTo("UbicacionSinTurno");
      setDataLoading(false);
      setOrdenesLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handlers mock para testing
  const handleVerRecepcionadosMock = () => {
    console.log(
      "🧪 MOCK: Navegando a turnos recepcionados",
      MOCK_TURNOS.recepcionados,
    );
    setTurnosRecepcionadosAll(MOCK_TURNOS.recepcionados)(
      turnosRecepcionadosDispatch,
    );
    setPaso("TurnosRecepionados")(pasoDispatch);
  };

  const handleMisTurnosDelDiaMock = () => {
    console.log("🧪 MOCK: Navegando a turnos del día", MOCK_TURNOS.pendientes);
    setCircuito("turnos")(pasoDispatch);
    setPaso("TurnosDelDia")(pasoDispatch);
  };
  // ========================= FIN MOCK DATA =========================

  // -------------------------  constantes ----------------------------
  const pacienteNombre = selectDropDownState?.selectDropDown?.selectGlobal
    ?.pacienteElegido?.paciente?.nombre
    ? selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido?.paciente
        ?.nombre
    : authState?.auth?.data?.paciente?.nombre;
  const idPacFamiliar = selectDropDownState?.selectDropDown?.selectGlobal
    ?.pacienteElegido?.paciente?.codigo
    ? selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido?.paciente
        ?.codigo
    : false;
  let config = localStorage.getItem("config");
  let parsedConfig = {};
  try { parsedConfig = JSON.parse(config) || {}; } catch (e) { parsedConfig = {}; }
  let opcMasInfoHome = parsedConfig.opcMasInfoHome;
  let opcAutoCheckIn = parsedConfig.opcAutoCheckIn;
  let opcAutoCheckInLabo = parsedConfig.opcAutoCheckInLabo;
  let opcMisInformes = parsedConfig.opcMisInformes;
  let opcMisLaboratorios = parsedConfig.opcMisLaboratorios;
  let opcOrdenDigital = parsedConfig.opcOrdenDigital;
  const history = useHistory();
  let portal = parsedConfig.portal;
  const noAsociar = sessionStorage.getItem("dismissOrden");
  const checkDevice = sessionStorage.getItem("checkDevice");
  const isNativePlatform = isNativeMobile();

  const filtroHorario =
    textosAutoCheckinState.textosAutoCheckin?.data?.filtroHorario?.orden;
  const minutosToleranciaRecepcion =
    parsedConfig?.minutosToleranciaRecepcion;
  const minRecepcionVariosTurnos = parsedConfig?.minRecepcionVariosTurnos;
  const coordenadas = ubicacionState?.ubicacion?.data;
  // -------------------------  constantes ----------------------------

  // -------------------------  funciones ----------------------------

  const nextStepTurnosPacienteDelDia = (isCorrect, turnosList) => {
    if (isCorrect && turnosList.length > 0) {
      // Separar turnos recepcionados (con presente) y pendientes (sin presente)
      const turnosConPresente = turnosList.filter((e) => e.presente);
      const turnosSinPresente = turnosList.filter((e) => !e.presente);

      // Actualizar estados para mostrar botones condicionalmente
      if (turnosConPresente.length > 0) {
        setHayTurnosRecepcionados(true);
      }
      if (turnosSinPresente.length > 0) {
        setHayTurnosPendientes(true);
      }

      // Calcular el siguiente paso para turnos pendientes
      const turnosOrdenamientoObj = turnosOrdenamiento(
        turnosSinPresente,
        filtroHorario,
        minutosToleranciaRecepcion,
        minRecepcionVariosTurnos,
      );
      if (opcAutoCheckInLabo) {
        const laboNoConfirmados = obtenerlaboNoConfirmados(turnosSinPresente);
        if (laboNoConfirmados.length > 0) {
          const idTipoPuntoControl = 15;
          setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
          setNextStepTo("PuntoControl");
        } else {
          if (
            turnosOrdenamientoObj.turnosLabo.length > 0 &&
            turnosOrdenamientoObj.turnosRecepcion.length === 0 &&
            turnosOrdenamientoObj.turnosPracticas.length === 0
          ) {
            setCircuito("labo")(pasoDispatch);
            setCircuito("turnosLabo")(pasoDispatch);
            setNextStepTo("UbicacionSinTurno");
          } else if (
            turnosOrdenamientoObj.turnosLabo.length === 0 &&
            (turnosOrdenamientoObj.turnosRecepcion.length > 0 ||
              turnosOrdenamientoObj.turnosPracticas.length > 0)
          ) {
            setCircuito("turnos")(pasoDispatch);
            setNextStepTo("UbicacionSinTurno");
          } else {
            setNextStepTo("SelectorCircuito");
          }
        }
      } else {
        setCircuito("turnos")(pasoDispatch);
        setNextStepTo("UbicacionSinTurno");
      }
    } else {
      setNextStepTo("SelectorCircuito");
    }

    setDataLoading(false);
  };

  const nextStepTurnosConPresente = (isCorrect, data) => {
    if (isCorrect && data) {
      // Hay turnos con presente, marcar el estado
      setTurnosSeleccionado([])(turnosSeleccionadosDispatch);
      setHayTurnosRecepcionados(true);

      // Igual buscar si hay turnos pendientes también
      wsGetTurnosPacienteDelDia(
        idPacFamiliar,
        (isCorrectPendientes, turnosList) => {
          if (isCorrectPendientes && turnosList.length > 0) {
            const turnosSinPresente = turnosList.filter((e) => !e.presente);
            if (turnosSinPresente.length > 0) {
              setHayTurnosPendientes(true);
              // Calcular el siguiente paso para turnos pendientes
              const turnosOrdenamientoObj = turnosOrdenamiento(
                turnosSinPresente,
                filtroHorario,
                minutosToleranciaRecepcion,
                minRecepcionVariosTurnos,
              );
              if (opcAutoCheckInLabo) {
                const laboNoConfirmados =
                  obtenerlaboNoConfirmados(turnosSinPresente);
                if (laboNoConfirmados.length > 0) {
                  const idTipoPuntoControl = 15;
                  setIdTipoPuntoControl(idTipoPuntoControl)(
                    puntoControlDispatch,
                  );
                  setNextStepTo("PuntoControl");
                } else {
                  if (
                    turnosOrdenamientoObj.turnosLabo.length > 0 &&
                    turnosOrdenamientoObj.turnosRecepcion.length === 0 &&
                    turnosOrdenamientoObj.turnosPracticas.length === 0
                  ) {
                    setCircuito("turnosLabo")(pasoDispatch);
                    setNextStepTo("UbicacionSinTurno");
                  } else if (
                    turnosOrdenamientoObj.turnosLabo.length === 0 &&
                    (turnosOrdenamientoObj.turnosRecepcion.length > 0 ||
                      turnosOrdenamientoObj.turnosPracticas.length > 0)
                  ) {
                    setCircuito("turnos")(pasoDispatch);
                    setNextStepTo("UbicacionSinTurno");
                  } else {
                    setNextStepTo("SelectorCircuito");
                  }
                }
              } else {
                setCircuito("turnos")(pasoDispatch);
                setNextStepTo("UbicacionSinTurno");
              }
            }
          }
          setDataLoading(false);
        },
      )(turnosAutoCheckInDispatch);
    } else {
      // No hay turnos con presente, buscar turnos pendientes
      wsGetTurnosPacienteDelDia(
        idPacFamiliar,
        nextStepTurnosPacienteDelDia,
      )(turnosAutoCheckInDispatch);
    }
  };
  // Handler para VER RECEPCIONADOS - va directo a la lista de turnos ya recepcionados
  const handleVerRecepcionados = () => {
    if (opcAutoCheckIn) {
      let nextStepPaso = (isCorrect, data) => {
        if (isCorrect && data) {
          const turnosConPresente = data.filter((e) => e.presente);
          setTurnosRecepcionadosAll(turnosConPresente)(
            turnosRecepcionadosDispatch,
          );
          setPaso("TurnosRecepionados")(pasoDispatch);
        }
      };
      setLoading("Cargando turnos recepcionados...");
      wsGetTurnosPacienteDelDia(
        idPacFamiliar,
        nextStepPaso,
      )(turnosAutoCheckInDispatch);
    } else {
      history.push("/proximosTurnos");
    }
  };

  // Handler para MIS TURNOS DEL DÍA - va a la lista de turnos pendientes de recepcionar
  const handleMisTurnosDelDia = () => {
    if (opcAutoCheckIn) {
      // Verificar si hay labo no confirmados primero
      let nextStepPaso = (isCorrect, data) => {
        if (isCorrect && data) {
          const laboNoConfirmados = obtenerlaboNoConfirmados(data);
          if (laboNoConfirmados.length > 0) {
            const idTipoPuntoControl = 15;
            setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
            setPaso("PuntoControl")(pasoDispatch);
          } else {
            setCircuito("turnos")(pasoDispatch);
            setPaso(nextStepTo)(pasoDispatch);
            setPasoSelectFamiliar(nextStepTo);
          }
        } else {
          setCircuito("turnos")(pasoDispatch);
          setPaso(nextStepTo)(pasoDispatch);
          setPasoSelectFamiliar(nextStepTo);
        }
      };
      setLoading("Cargando turnos del día...");
      wsGetTurnosPacienteDelDia(
        idPacFamiliar,
        nextStepPaso,
      )(turnosAutoCheckInDispatch);
    } else {
      history.push("/proximosTurnos");
    }
  };

  const handleNecesitoTurno = () => {
    // sessionStorage.setItem("centroID", 9);
    setPasoSelectFamiliar(false);
    setPaso("SelectFamiliar")(pasoDispatch);
  };
  // const handleOtrosTramites = () => {
  //   setPaso("OtrosTramites")(pasoDispatch);
  // };
  const handleProximosTurnos = () => {
    history.push("/proximosTurnos");
  };
  const handleOrdenesPendientes = () => {
    if (isNativePlatform) {
      // En app nativa: preguntar si está cerca del centro
      setCircuito("ordenes")(pasoDispatch);
      setPaso("UbicacionSinTurno")(pasoDispatch);
    } else {
      // En web: redirigir directamente a órdenes digitales
      history.push("/ordenesDigitales");
    }
  };
  const handleLaboratorio = () => {
    setCircuito("labo")(pasoDispatch);
    setPaso("HomeLabo")(pasoDispatch);
  };
  const handleResultados = () => {
    setPaso("Resultados")(pasoDispatch);
  };

  const dismissOrdenDig = () => {
    hideModal()(modalDispatch);
    sessionStorage.setItem("dismissOrden", true);
  };

  const turnosOrdenadosFun = (turnosList) => {
    const turnosOrdenados = OrderTurnosLabo(
      turnosList,
      filtroHorario,
      minutosToleranciaRecepcion,
      minRecepcionVariosTurnos,
      coordenadas,
    );
    return turnosOrdenados;
  };

  const obtenerlaboConfirmados = (turnosList) => {
    const turnosOrdenados = turnosOrdenadosFun(turnosList);
    const laboConfirmados = turnosOrdenados.filter(
      (turno) =>
        turno.estadoProtocolo > 1 &&
        turno.estadoProtocolo < 4 &&
        turno.type === "laboratorio" &&
        turno.selected,
    );
    return laboConfirmados;
  };

  const obtenerlaboNoConfirmados = (turnosList) => {
    const turnosOrdenados = turnosOrdenadosFun(turnosList);
    const laboNoConfirmados = turnosOrdenados.filter(
      (turno) => turno.estadoProtocolo === 1 && turno.type === "laboratorio",
    );
    return laboNoConfirmados;
  };
  const obtenerlaboPresentes = (turnosList) => {
    const turnosOrdenados = turnosOrdenadosFun(turnosList);
    const laboPresentes = turnosOrdenados.filter(
      (turno) => turno.estadoProtocolo === 4 && turno.type === "laboratorio",
    );
    return laboPresentes;
  };

  const nextStepOrdenes = (isCorrect, data) => {
    if (isCorrect) {
      wsGetLabOrdenDigital(-1, (isCorrect, dataLabo) =>
        nextStepLabo(isCorrect, data, dataLabo),
      )(labOrdenDigitalDispatch);
    } else {
      showToaster(
        {
          texto: "Error al obtener ordenes digitales.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
      setOrdenesLoading(false);
    }
  };

  const nextStepLabo = (isCorrect, data, dataLabo) => {
    if (isCorrect) {
      if (dataLabo.length > 0 || data.length > 0) {
        sessionStorage.setItem("getOrdenes", true);
        let ordenesConcat = [...data, ...dataLabo];
        let ordenesSinAsociar = ordenesConcat.filter(
          (orden) =>
            orden.idTurno === null ||
            orden.idTurno === -1 ||
            orden.idLabProtAgenda === null ||
            orden.idLabProtAgenda === 0,
        );
        let ordenByFecha = ordenesSinAsociar.sort((a, b) => {
          const fechaA = a.fechaAlta || a.fechaalta;
          const fechaB = b.fechaAlta || b.fechaalta;
          return new Date(fechaB).getTime() - new Date(fechaA).getTime();
        });
        setOrdenesLoading(false);
        sessionStorage.setItem("ordenesList", JSON.stringify(ordenByFecha));
        modalOrdenesSinAsociar();
      } else {
        sessionStorage.setItem("dismissOrden", true);
        setOrdenesLoading(false);
      }
    } else {
      setOrdenesLoading(false);
      showToaster(
        {
          texto: "Error al obtener ordenes de laboratorio.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  const modalOrdenesSinAsociar = () => {
    showModal(
      "Genericos/OrdenSinAsociar/OrdenSinAsociar",
      {
        dissmiss: () => dismissOrdenDig(),
        navigateTo: () => {
          setCircuito("ordenes")(pasoDispatch);
          navigation("UbicacionSinTurno");
        },
      },
      [],
      "centro",
      true,
    )(modalDispatch);
  };

  const navigation = (path) => {
    setPaso(path)(pasoDispatch);
  };
  // // -------------------------  funciones ----------------------------

  // // -------------------------  useEffect ----------------------------
  // Si vengo desde autoterminalDesktop desde el celular automaticamente pasa
  // a la pantalla de necesito turno
  let turnoMobile = sessionStorage.getItem("turnoMobile");

  useEffect(() => {
    //complemento textos siempre lo ultimo
    wsGetTextos()(textosDispatch);
    sessionStorage.setItem("homeAutocheck", "true");
    setCircuito(null)(pasoDispatch);
    return () => {
      sessionStorage.setItem("homeAutocheck", "false");
    };
  }, []);

  useEffect(() => {
    if (turnoMobile) {
      setPaso("NecesitoTurno")(pasoDispatch);
      sessionStorage.removeItem("turnoMobile");
    }
  }, [turnoMobile]);

  useEffect(() => {
    const aplicarPasoInicial = () => {
      const pasoInicial = sessionStorage.getItem("pasoInicialAutocheckin");
      if (pasoInicial) {
        setPaso(pasoInicial)(pasoDispatch);
        sessionStorage.removeItem("pasoInicialAutocheckin");
      }
    };
    aplicarPasoInicial();
    window.addEventListener("setPasoInicialAutocheckin", aplicarPasoInicial);
    return () => {
      window.removeEventListener("setPasoInicialAutocheckin", aplicarPasoInicial);
    };
  }, []);

  useEffect(() => {
    let publicidad = textosState?.textos?.data?.publicidades;
    let view;
    try { view = JSON.parse(localStorage.getItem("publicidad_portal")); } catch (e) { view = null; }
    if (publicidad && publicidad.length > 0 && !view) {
      showModal(
        "Turnos/Publicidad/Publicidad",
        {
          publicidad: publicidad,
        },
        [],
        "centro",
        true,
      )(modalDispatch);
    }
  }, [
    textosState?.textos?.data?.publicidades,
    estudioGrupoState?.estudioGrupo?.loading,
  ]);

  useEffect(() => {
    if (opcAutoCheckIn) {
      if (isNativePlatform) {
        wsGetTurnosConPresente(
          idPacFamiliar,
          nextStepTurnosConPresente,
        )(turnosAutoCheckInDispatch);
        if (noAsociar === undefined || noAsociar === null) {
          setOrdenesLoading(true);
          wsGetOrdenDigitalEstudio(
            authState?.auth?.data?.paciente?.codigo,
            nextStepOrdenes,
          )(ordenDigitalDispatch);
        } else {
          setOrdenesLoading(false);
        }
      } else {
        setDataLoading(false);
        setOrdenesLoading(false);
      }
    } else {
      setDataLoading(false);
    }

    LimpiarSelectGlobal()(selectDropDownDispatch);
  }, [checkDevice]);

  useEffect(() => {
    if (avisoAutocheckState.avisoAutocheck.show) {
      showModal(
        "Genericos/AvisoAutocheck/AvisoAutocheck",
        { aceptar: aceptarTiempoExtra, disableback: true },
        [],
        "centro",
        true,
      )(modalDispatch);
    }
  }, [avisoAutocheckState.avisoAutocheck.show]);

  // // -------------------------  useEffect ----------------------------

  const aceptarTiempoExtra = () => {
    setAvisoAutocheck(false)(avisoAutocheckDispatch);
    hideModal()(modalDispatch);
  };

  return (
    <>
      <Loading
        dataLoading={dataLoading || ordenesLoading}
        color="c-white"
        descripcion={"Cargando..."}
      />
      {dataLoading ? (
        ""
      ) : (
        <Layout origen={"NULL"} positionSidebar={21}>
          <ContianerHome $isNative={isNativePlatform}>
            <HeaderHomeBar
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{
                duration: 1.5,
                ease: "easeInOut",
                opacity: [0, 0.3, 0.7, 1],
                times: [0, 0.3, 0.7, 1],
              }}
            >
              <span className="title">
                ¡Hola{" "}
                <span className="title-negrita">
                  {camelize(pacienteNombre)}
                </span>
                !{" "}
              </span>
              <span className="title-pregunta">
                ¿En que podemos ayudarte{" "}
                <span className="title-negrita">hoy</span>?
              </span>
            </HeaderHomeBar>
            <BtnContainer
              initial={{ opacity: 0, y: +100 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 100 }}
              transition={{ duration: 0.4 }}
              $opcMasInfoHome={opcMasInfoHome}
              $isNative={isNativePlatform}
            >
              {/* Botón VER RECEPCIONADOS - solo si hay turnos con presente */}
              {hayTurnosRecepcionados && (
                <BtnLink
                  Icon={<CalendarCheckIcon color={"var(--color-primary)"} />}
                  type={"GREEN"}
                  title={"VER RECEPCIONADOS"}
                  onclick={
                    MOCK_ENABLED
                      ? handleVerRecepcionadosMock
                      : handleVerRecepcionados
                  }
                />
              )}
              {/* Botón MIS TURNOS DEL DÍA - solo si hay turnos pendientes */}
              {hayTurnosPendientes && (
                <BtnLink
                  Icon={<RelojIcon color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={"MIS TURNOS DEL DÍA"}
                  onclick={
                    MOCK_ENABLED
                      ? handleMisTurnosDelDiaMock
                      : handleMisTurnosDelDia
                  }
                />
              )}
              <BtnLink
                Icon={<CalendarSearchIcon color={"var(--color-primary)"} />}
                type={"NORMAL"}
                title={"NECESITO UN TURNO"}
                onclick={handleNecesitoTurno}
              />
              {opcAutoCheckInLabo && (
                <BtnLink
                  Icon={<InjectionIcon color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={"LABORATORIO"}
                  onclick={handleLaboratorio}
                />
              )}
              {opcOrdenDigital && (
                <BtnLink
                  Icon={<OrdenesDigitalesIcon color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={
                    isNativePlatform ? "ÓRDENES PENDIENTES" : "ÓRDENES MÉDICAS"
                  }
                  onclick={handleOrdenesPendientes}
                />
              )}
              {(opcMisInformes || opcMisLaboratorios) && (
                <BtnLink
                  Icon={<OtrosTramites color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={"RESULTADOS"}
                  onclick={handleResultados}
                />
              )}
              <BtnLink
                Icon={<MiTurnoIcon color={"var(--color-primary)"} />}
                type={"NORMAL"}
                title={"PRÓXIMOS TURNOS"}
                onclick={handleProximosTurnos}
              />

              {opcMasInfoHome ? (
                <BtnLink
                  Icon={<AlertIconFilled color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={"MÁS INFORMACIÓN"}
                  onclick={() => {}}
                />
              ) : (
                ""
              )}
            </BtnContainer>

            {portal && portal === "dim" ? (
              <div className="logo-dim">
                <LogoDim height={"550"} />
              </div>
            ) : (
              ""
            )}
          </ContianerHome>
        </Layout>
      )}
    </>
  );
};

export default Home;
